import { observer } from 'mobx-react-lite';
import { Dispatch, SetStateAction, useState } from 'react';
import { Button, Input, Modal } from 'semantic-ui-react';
import AssetDragDrop from '../../app/common/folderfiles/AssetDragDrop';
import { useStore } from '../../app/stores/store';
import agent from '../../app/api/agent';

type Props = {
  showUpdateLogo: Dispatch<SetStateAction<boolean>>;
  updateLogo: boolean;
};

function UploadLogo({ showUpdateLogo, updateLogo }: Props) {
  const {
    commonStore,
    userStore: { setLogo, getLogo, user, appLogo },
  } = useStore();
  const [files, setFiles] = useState<File[]>([]);
  const [fileUrl, setFileUrl] = useState<string>('');

  const onDrop = (acceptedFiles: File[]) => {
    setFiles(
      acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        }),
      ),
    );
  };

  const upload = () => {
    files.forEach(async (file) => {
      if (commonStore.devEnv) {
        await agent.Files.localFileUpload(
          file,
          'Profile',
          user?.customerName || user?.id,
        ).then((Response) => {
          if (Response.data) {
            const url = Response.data.path.replace(/\\\\/g, '\\');
            setFileUrl(url);
          }
        });
      } else {
        await agent.Files.uploadFile(file).then((Response) => {
          if (Response.data) {
            setFileUrl(Response.data?.url);
          }
        });
      }
      setFiles([]);
    });
  };

  const handleSave = async () => {
    await agent.Profiles.deleteAppLogo({ Id: appLogo.id })
      .then(() => {
        setTimeout(() => {
          setLogo({ Url: fileUrl });
        }, 200);
      })
      .then(() => {
        setTimeout(() => {
          getLogo();
        }, 200);
      });
    showUpdateLogo(false);
  };

  return (
    <div>
      <Modal
        onClose={() => showUpdateLogo(false)}
        onOpen={() => showUpdateLogo(true)}
        open={updateLogo}
      >
        <Modal.Header>Update Application Logo</Modal.Header>

        <Modal.Content>
          <Input
            type="text"
            label="Enter Image URL for Logo"
            value={fileUrl}
            onChange={(e) => setFileUrl(e.currentTarget.value)}
          />
          <br />
          <br />
          Or
          <AssetDragDrop files={files} onDrop={onDrop} name={''} />
          <Button onClick={upload} positive>
            Upload
          </Button>
          <Button color="orange" onClick={() => setFileUrl('/assets/logo.png')}>
            Set Default
          </Button>
        </Modal.Content>
        <Modal.Actions className="smallscreenedit">
          <Button.Group>
            <Button onClick={() => showUpdateLogo(false)}>Cancel</Button>
            <Button.Or />
            <Button color={'blue'} onClick={handleSave}>
              Save
            </Button>
          </Button.Group>
        </Modal.Actions>
      </Modal>
    </div>
  );
}

export default observer(UploadLogo);
